import {
  ContentDetailCard,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  resourceTypeName,
} from '@geneo2-web/shared-ui';
import { Box, Checkbox } from '@mui/material';
import { Resource_ResourceEnum } from '@protos/content_management/content.db_pb';
import { ResourceInfo } from '@protos/content_management/content.common.apis_pb';
import { getResourcePosterBucket } from '../../utils';

interface IProps {
  resource: ResourceInfo;
  checked: boolean;
  disabled: boolean;
  locked: boolean;
  onToggle: () => void;
  onPreview: () => void;
}

// Checkbox selects; card click previews.
export default function SelectableResourceCard(props: IProps) {
  const { resource, checked, disabled, locked, onToggle, onPreview } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
        border: '1px solid',
        borderColor: checked ? 'primary.main' : 'transparent',
        opacity: locked ? 0.5 : 1,
      }}
    >
      <Checkbox
        checked={checked}
        disabled={disabled || locked}
        onChange={onToggle}
        inputProps={{
          'aria-label': `${locked ? 'Locked: ' : 'Select '}${resource.title}`,
        }}
      />
      <ContentDetailCard
        onClick={onPreview}
        isLocked={locked}
        variant={'small'}
        image={getMediaBasePath(
          resource.posterImageUrl,
          getResourcePosterBucket(resource)
        )}
        heading={resource.title}
        iconDetails={[
          {
            iconName: 'clock',
            text: resource.estimatedTimeInMin.toString() + ' min',
          },
          {
            iconName: resourceTypeName(resource.resourceType).icon,
            text: resourceTypeName(resource.resourceType).name,
          },
        ]}
        showVideoIcon={
          resource.resourceType === Resource_ResourceEnum.RESOURCE_TYPE_VIDEO
        }
        rootStyle={{
          width: { xs: pxToRem(250), md: pxTovW(450), lg: pxTovW(300) },
          height: { xs: pxToRem(102), md: pxTovW(150), lg: pxTovW(88) },
        }}
      />
    </Box>
  );
}
